import React, { Component } from "react";

import {
  Card,
  Button,
  Table,
  BackTop,
  Select,
  Input,
  Modal,
  message,
  Tag,
} from "antd";

import { connect } from "react-redux";
import {
  req_add_sys_eventLog,
  req_page_eca_english_course_students,
  req_downloadfile_eca_course_students,
  req_list_eca_activity_participate_points,
  req_edit_eca_student_grades,
  req_edit_eca_student_real_grades,
  req_single_eca_lockedTag,
  req_edit_eca_students_real_grades,
  req_delete_eca_course_student,
} from "../../api";

import {
  SYS_CODE,
  API_BASE,
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { UI_BUTTON, BUTTON_UPLOAD } from "../../utils/words";
import { usrRole } from "../../utils/dataUtil";
import {
  getNowAcademicYear,
  getNowAcademicSemester,
} from "../../utils/dateUtil";
import memoryUtils from "../../utils/memoryUtils";

import StudentPointsModal from "./student-points-modal";

class UIEnglishCourseStudents extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: 0,
    loading: false,
    userLevel: "NORMAL",
    items: [],
    item: {},
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",

    domnloadFile: "",

    nowAcademicYear: getNowAcademicYear(new Date()),
    nowAcademicSemester: getNowAcademicSemester(new Date()),
    points: [],
    isShowModal: false,

    lockGradesUploadStatus: "N",
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_page_items(1);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resize.bind(this));
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = async (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { pageSize } = this.state.pagination;
    const { searchField, searchValue, columnSort, orderBy, filterStatus } =
      this.state;
    const { token, userCode, role } = this.props.user;
    const { OpenCourseIdKey } = this.props.location.state;

    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true });
    const result = await req_page_eca_english_course_students(
      userCode,
      userLevel,
      OpenCourseIdKey,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      token
    );
    this.setState({ loading: false });

    //console.log(result)
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
      //console.log(this.state);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
    this.api_get_lockedTag_item();
  };

  api_downloadfile_items = async () => {
    const { OpenCourseIdKey } = this.props.location.state;
    const { searchField, searchValue, filterStatus } = this.state;
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    const fileUrl = await req_downloadfile_eca_course_students(
      userCode,
      userLevel,
      OpenCourseIdKey,
      searchField,
      searchValue,
      filterStatus,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "學生成績清單";
    a.click();
  };

  api_list_items = async (item) => {
    //console.log(this.props.student)
    const { AcademicYear, AcademicSemester, StudentId } = item;
    const { token } = this.props.user;

    const result = await req_list_eca_activity_participate_points(
      AcademicYear,
      AcademicSemester,
      StudentId,
      token
    );

    // console.log(result)
    if (result) {
      const points = result;
      this.setState({ points });
      //console.log(this.state);
    } else {
      const points = [];
      this.setState({ points });
    }
  };

  api_modify_item = async (item) => {
    const { token } = this.props.user;
    await req_edit_eca_student_grades(item, token);
    this.api_page_items(this.current);
  };

  api_delete_item = async (uid) => {
    const { token } = this.props.user;
    await req_delete_eca_course_student(uid, token);
    this.api_page_items(this.current);
  };

  api_modify_all_grades = async (openCourseIdKey) => {
    const { token } = this.props.user;
    this.setState({ loading: true });
    const result = await req_edit_eca_students_real_grades(
      openCourseIdKey,
      token
    );
    this.setState({ loading: false });
    if (result === "success") {
      message.info("所有學生平常成績上傳成功");
    } else {
      message.error("所有學生平常成績上傳失敗");
    }
  };

  api_update_item = async (item) => {
    const { key, grade, gradeAvg } = item;
    const result = await req_edit_eca_student_real_grades(key, grade, gradeAvg);
    //console.log(result)
    if (result === "success") {
      message.info("平常成績上傳成功");
    } else {
      message.error("平常成績上傳失敗");
    }
  };

  api_get_lockedTag_item = async () => {
    const { token } = this.props.user;
    const tag = await req_single_eca_lockedTag("GRADES_UPLOAD", token);
    this.setState({ lockGradesUploadStatus: tag.isLocked });
  };

  api_save_event_log = async (item) => {
    const { token } = this.props.user;
    await req_add_sys_eventLog(item, token);
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "開課流水號",
        dataIndex: "OpenCourseIdKey",
        width: 30,
        responsive: ["md"],
      },
      {
        title: "科目代碼",
        dataIndex: "CourseCode",
        width: 30,
        responsive: ["md"],
      },
      {
        title: "課程名稱",
        dataIndex: "CourseTwName",
        width: 40,
        responsive: ["md"],
      },
      {
        title: "學號",
        dataIndex: "StudentId",
        width: 40,
        responsive: ["md"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "姓名",
        dataIndex: "TwName",
        width: 40,
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "平常成績",
        width: 45,
        render: (item) => {
          const { lockGradesUploadStatus } = this.state;
          const { GradeIdKey, UsualGradesA, GradesAPct } = item;
          const Placeholder = GradesAPct + "%";
          return (
            <>
              <Input
                disabled={lockGradesUploadStatus === "Y" ? true : false}
                placeholder={Placeholder}
                style={{
                  width: 60,
                  margin: "0 5px",
                  backgroundColor: "LightYellow",
                  color: "black",
                }}
                defaultValue={UsualGradesA}
                onChange={(e) =>
                  this.handle_ui_field_change(GradeIdKey, "GRADEA", e)
                }
              />{" "}
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                onClick={() => this.handle_show_ui_modal("delete", item)}
              >
                <i className="fas fa-user-alt-slash"></i>
                <span> 退選</span>
              </button>
            </>
          );
        },
      },
      {
        title: "自學成績",
        width: 40,
        render: (item) => {
          const { UsualGradesC, GradesCPct, GradeIdKey } = item;
          const Placeholder = GradesCPct + "%";
          return (
            <>
              <Input
                placeholder={Placeholder}
                style={{ width: 60, margin: "0 5px", color: "blue" }}
                value={UsualGradesC}
                onChange={(e) =>
                  this.handle_ui_field_change(GradeIdKey, "GRADEC", e)
                }
                disabled={true}
              />
            </>
          );
        },
      },
      {
        title: "平均",
        dataIndex: "UsualGradeAvg",
        width: 25,
        render: (field) => {
          return (
            <div>
              <span
                style={
                  field > 59
                    ? { color: "green", fontSize: "1.3em", fontWeight: "bold" }
                    : { color: "red", fontSize: "1.3em", fontWeight: "bold" }
                }
              >
                {" "}
                {field}
              </span>
            </div>
          );
        },
      },
      {
        title: "",
        dataIndex: "",
        width: 65,
        responsive: ["md"],
        render: (item) => {
          const { TotalPoints } = item;
          // const { lockGradesUploadStatus } = this.state;
          return (
            <>
              {/* <button
                type="button"
                className="btn btn-outline-danger btn-sm"
                onClick={() => this.handle_process_grade(item)}
                disabled={lockGradesUploadStatus === "Y" ? true : false}
                style={
                  lockGradesUploadStatus === "Y"
                    ? { display: "none" }
                    : { display: "block" }
                }
              >
                <i className="fas fa-file-upload"></i>
                <span> 上傳個別成績</span>
              </button>{" "} */}
              {TotalPoints > 0 ? (
                <>
                  <button
                    type="button"
                    className="btn btn-outline-success btn-sm"
                    onClick={() => this.handle_show_ui_modal("view", item)}
                  >
                    <span>得點：</span>{" "}
                    <span className="badge badge-primary">{TotalPoints}</span>
                  </button>
                </>
              ) : (
                ""
              )}
            </>
          );
        },
      },
    ];
  };

  style_switch_color_tag(column, param) {
    switch (column) {
      case "NoneTotal":
        break;
      case "NeedOutreachTotal":
        break;
      case "TutorWaitConfirmTotal":
        break;
      default:
        break;
    }
  }
  // 操作互動處理 //////////////////////////////////////////////

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_delete_student = (item) => {
    console.log(item);
    //this.api_del_item(item)
  };

  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_data_download = () => {
    this.api_downloadfile_items();
  };

  handle_show_ui_modal = (modal, item) => {
    switch (modal) {
      case "view":
        this.api_list_items(item);
        this.setState({ isShowModal: true });
        break;
      case "edit":
        this.setState({ isEditModal: true, item });
        break;
      case "add":
        this.setState({ isAddModal: true });
        break;
      case "delete":
        const { uid } = item;
        Modal.confirm({
          title: `您確定刪除此人員`,
          onOk: () => {
            this.api_delete_item(uid);
          },
        });
        break;
      case "download":
        break;
      default:
    }
    //console.log(memoryUtils.pagination.isGoNext)
  };

  handle_ui_field_change = (target_key, target_field, e) => {
    let value = e.target.value;
    let getValue = parseInt(value, 10);

    if (isNaN(getValue)) {
      getValue = 0;
    }

    if (getValue <= 100 && getValue >= 0) {
      const item = {
        GradeIdKey: target_key,
        UsualGradesA: getValue,
        UsualGradesB: getValue,
        UsualGradesC: getValue,
        condition: target_field,
      };
      //console.log(target_key)
      this.api_modify_item(item);
    } else {
      message.info("數字僅能介於0至100");
    }
  };

  handle_pages_back_stautus = () => {
    memoryUtils.pagination.isGoBack = true;
    this.props.history.goBack();
  };

  handle_process_grade = (item) => {
    const data = {
      key: item.GradeIdKey,
      grade: item.UsualGradeAvg,
      gradeAvg: item.UsualGradeAvg,
    };
    this.api_update_item(data);
  };

  handle_process_grades = () => {
    const { OpenCourseIdKey } = this.props.location.state;
    this.api_modify_all_grades(OpenCourseIdKey);
    this.handle_event_log(
      "english-course-students",
      "handle_process_grades",
      OpenCourseIdKey
    );
  };

  handle_event_log = (uiname, eventname, description) => {
    const { userCode } = this.props.user;
    const event = {
      SystemDomain: SYS_CODE,
      UIFileName: uiname,
      EventName: eventname,
      UIType: UI_BUTTON,
      UIName: BUTTON_UPLOAD,
      EventUser: userCode,
      EventDescription: description,
    };
    //console.log(event);
    this.api_save_event_log(event);
  };

  /////////////////////////////////////////////////////////////
  render() {
    const { OpenCourseDepartment, OpenClassroomName } =
      this.props.location.state;
    const {
      loading,
      items,
      pagination,
      searchField,
      searchValue,
      deviceWidth,
      isShowModal,
      points,
      lockGradesUploadStatus,
    } = this.state;

    const title = (
      <>
        <Button
          type="link"
          style={{ color: "green", fontSize: 25 }}
          onClick={() => this.handle_pages_back_stautus()}
        >
          <i className="fas fa-angle-double-left"></i>
        </Button>
        <span style={{ color: "green", fontSize: 18 }}>
          {OpenCourseDepartment + " / " + OpenClassroomName}
        </span>
        <p />
        <Select
          value={searchField}
          style={{ width: 120 }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="NONE">搜索條件</Select.Option>
          <Select.Option value="StudentId">學號</Select.Option>
          <Select.Option value="TwName">學生姓名</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 80, backgroundColor: "LightYellow", margin: "0 5px" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}> 查詢</span>
        </Button>{" "}
        {deviceWidth > 600 ? (
          <>
            <Button type="primary" onClick={() => this.handle_data_download()}>
              <i className="fas fa-cloud-download-alt element-hidden"></i>
              <span style={{ marginLeft: "4px" }}> 下載</span>
            </Button>
          </>
        ) : (
          ""
        )}{" "}
        {/* <button
          type="button"
          className="btn btn-outline-danger btn-sm"
          onClick={() => this.handle_process_grades()}
          disabled={lockGradesUploadStatus === "Y" ? true : false}
          style={
            lockGradesUploadStatus === "Y"
              ? { display: "none" }
              : { display: "block" }
          }
        >
          <i className="fas fa-file-import"></i>
          <span style={{ marginLeft: "4px" }}> 上傳所有成績</span>
        </button> */}
        <br></br>
        <Tag
          color="#cd201f"
          style={
            lockGradesUploadStatus === "Y"
              ? { display: "none" }
              : { display: "block" }
          }
        >
          註：關閉[成績上傳]後，如須修正成績，請至教務處成績系統處理。
        </Tag>
      </>
    );
    return (
      <Card>
        <>{title}</>
        <p>
          <Tag color="#2B3557 ">註：固定每日午夜12時結算點數</Tag>
        </p>
        <Table
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          rowKey="Uid"
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            // onChange: this.api_page_applycase,
            onShowSizeChange: this.handle_page_size_change,
          }}
          columns={this.columns}
        />
        <Modal
          destroyOnClose={true}
          visible={isShowModal}
          width={1000}
          onOk={() => {
            this.setState({ isShowModal: false });
          }}
          onCancel={() => {
            this.setState({ isShowModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <StudentPointsModal points={points} />
        </Modal>
        <BackTop visibilityHeight="80" />
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(UIEnglishCourseStudents);
